import React from 'react';
import { Link } from 'react-router-dom';

// Builds the link from a dashboard/report figure to the records behind it.
// The drill-down page calls the backend drill-down, which uses the same
// calculation as the figure (services/drilldown, services/balanceDrill), so the totals match.
export function drillHref({ metric, start, end, business, category, account, type, kind, side, rollup, networth, formula } = {}) {
  const p = new URLSearchParams();
  if (kind) p.set('kind', kind);
  if (formula) p.set('formula', formula);
  if (side) p.set('side', side);
  if (rollup) p.set('rollup', 'true');
  if (networth) p.set('networth', 'true');
  if (metric) p.set('metric', metric);
  if (start) p.set('start_date', start);
  if (end) p.set('end_date', end);
  if (business) p.set('business_id', String(business));
  if (category !== undefined && category !== null && category !== '') p.set('category_id', String(category));
  if (account) p.set('account_id', String(account));
  if (type) p.set('transaction_type', type);
  return `/drilldown?${p.toString()}`;
}

// Figures that are worked out from other figures. Each part is itself a drill-down,
// so the breakdown page shows every part, its amount and a link to the records
// behind it. Scope (business, roll-up, dates) is carried through to every part.
export const FORMULAS = {
  'buying-power': { label: 'Buying power', parts: [
    { sign: 1, label: 'Cash in asset accounts', link: { kind: 'accounts', side: 'liquid' } },
    { sign: 1, label: 'Available credit on debt accounts', link: { kind: 'accounts', side: 'credit' } }] },
  'net-accounts': { label: 'Net accounts', parts: [
    { sign: 1, label: 'Asset account balances', link: { kind: 'accounts', side: 'liquid' } },
    { sign: -1, label: 'Amounts owed on debt accounts', link: { kind: 'accounts', side: 'liabilities' } }] },
  'net-worth': { label: 'Net worth', parts: [
    { sign: 1, label: 'Total assets', link: { kind: 'total-assets' } },
    { sign: -1, label: 'Total liabilities', link: { kind: 'accounts', side: 'liabilities', networth: true } }] },
  equity: { label: 'Equity', parts: [
    { sign: 1, label: 'Total assets', link: { kind: 'total-assets' } },
    { sign: -1, label: 'Total liabilities', link: { kind: 'accounts', side: 'liabilities' } }] }
};

/** Drill links for each part of a formula, with the clicked figure's scope. */
export function formulaParts(name, scope = {}) {
  const f = FORMULAS[name];
  if (!f) return [];
  return f.parts.map((part) => ({ ...part, href: drillHref({ ...scope, ...part.link }) }));
}

export function DrillLink({ to, children, className = '' }) {
  return (
    <Link to={to} className={`hover:underline ${className}`} title="See the records behind this number">
      {children}
    </Link>
  );
}
